import React, {
  forwardRef,
  useEffect,
  useImperativehandler,
  useState,
} from "react";
import { GridRowModes } from "@mui/x-data-grid";
import {
  dateControlDropdown,
  getAcdLabelValue,
  newRow,
  viewTextStyle,
} from "./constant";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import CategorySelector from "views/pages/manage/unAssigned/studentCharges/studentChargesDetails/concessionDetails/categorySelector.js";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import { editCellContainerStyle } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { saveOrDeleteMsg } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { selectStyles } from "views/pages/manage/masters/holidayMaster/common";
import { isObjEmpty } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { generateRandomId } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import ActionsCellComponent from "./ActionCellComponent";
import moment from "moment";
import { Tooltip } from "@mui/material";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import StatusCellComponent from "./StatusCellComponent";
import CustomChip from "views/pages/manage/common/customChip/CustomChip";
import { regex } from "views/pages/manage/common/constant";

import { useImperativeHandle } from "react";
import AuditLogDialogWithButton from "./AuditLogDialogWithButton";
const AInputStyle = { height: "40px", borderRadius: "4px" };

const ListComponent = forwardRef(
  (
    {
      currentPage = 0,
      rowCount,
      dropdown,
      rows,
      loader,
      createHandler,
      updateHandler,
      isNew,
      setIsNew,
      toggleStatusHandler,
      allConcessionCategories,
      userPermissions,
    },
    ref
  ) => {
    const [rowModesModel, setRowModesModel] = useState({});
    const [concessionCategory, setConcessionCategory] = useState("");
    const [rowData, setRowData] = useState(rows);
    const [rowForm, setRowForm] = useState({});

    useEffect(() => setRowData(rows), [rows]);

    const rowFormHandler = (value, key) => {
      setRowForm((prev) => ({ ...prev, [key]: value }));
    };
    const startEditing = (id, form) => {
      setRowModesModel((oldModel) => ({ [id]: { mode: GridRowModes.Edit } }));
      setRowForm({
        ...form,
        itemType: dropdown?.itemTypes?.find(
          (el) => el?.label === form?.itemType
        ),
      });
    };

    const stopEditing = () => {
      const currForm = { ...rowForm };
      setRowModesModel((oldModel) => ({
        [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
      }));
      setRowForm({});
    };
    const handleEditClick = (params) => {
      if (!isObjEmpty(rowForm)) {
        failureToast(saveOrDeleteMsg);
      } else {
        setConcessionCategory(params?.row?.concessionCategory);
        startEditing(
          params?.id,

          params?.row
        );
      }
    };

    const handleCancelClick = async (params) => {
      if (params?.row?.isNew) {
        setRowData(rows);
        setRowForm({});
        setIsNew(false);
      } else {
        stopEditing(params?.id);
      }
      setConcessionCategory("")
    };

    const handleSaveClick = async (params) => {
      if (rowForm?.isNew) {
        await createHandler(rowForm, concessionCategory);
        setIsNew(false);
      } else {
        await updateHandler(rowForm, concessionCategory);
      }
    };

    const addNewRow = async () => {
      if (!isObjEmpty(rowForm)) {
        failureToast(saveOrDeleteMsg);
      } else {
        setIsNew(true);
        let randomId = generateRandomId();
        let emptyRow = { ...newRow, isNew: true, id: randomId };
        startEditing(randomId, emptyRow);
        setRowData((prev) => [emptyRow, ...prev]);
      }
    };

    useImperativeHandle(ref, () => ({
      addNewRow: addNewRow,
      startEditing: startEditing,
      stopEditing: stopEditing,
    }));

    const columns = [
      new AGridColDef("concessionCategory", "Type", false)
        .setMinWidth(210)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) =>
          params?.value ? (
            <div>
              <Tooltip title={params?.value?.subSubCategoryDisplayValue}>
                <div className={`ellipsis-text-container`}>
                  {params?.value?.subSubCategoryDisplayValue}
                </div>
              </Tooltip>
            </div>
          ) : (
            <div>-</div>
          )
        )
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <CategorySelector
              allAppliedConcList={[]}
              applicationDetails={{}}
              allCategories={allConcessionCategories}
              userPermissions={userPermissions}
              prospectusSlabs={[]}
              isCategorySelectorDisabled={() => {}}
              concessionModificationAllowed={false}
              row={{ code: [{ value: "C" }] }}
              isConcessionReversalMasterFlow={true}
              updateConcessionData={(value) => setConcessionCategory(value)}
              currentConcessionData={concessionCategory}
            />
          </div>
        )),
      new AGridColDef("academicCareer", "Academic career", false)
        .setMinWidth(180)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) =>
          params?.value ? (
            <div>
              <Tooltip title={getAcdLabelValue(params?.value)}>
                <div className={`ellipsis-text-container`}>
                  {getAcdLabelValue(params.value)}
                </div>
              </Tooltip>
            </div>
          ) : (
            <div>-</div>
          )
        )
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.academicCareer}
              handleChange={(value) => rowFormHandler(value, "academicCareer")}
              items={dropdown?.academicCareer}
              style={selectStyles}
              placeHolder={"Enter"}
              autoFocus={params?.hasFocus}
              isShowCount={true}
            />
          </div>
        )),

      new AGridColDef("noOfDays", "No. Of Days", false)
        .setMinWidth(120)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) =>
          params?.value ? (
            <div>
              <Tooltip title={params?.value}>
                <div className={`ellipsis-text-container`}>{params?.value}</div>
              </Tooltip>
            </div>
          ) : (
            <div>-</div>
          )
        )
        .renderEditCellComponent((params) => (
          <div>
            <AInput
              value={rowForm?.noOfDays}
              handler={(value) => rowFormHandler(value, "noOfDays")}
              placeHolder={"Enter"}
              style={AInputStyle}
              regex={new RegExp(/^$|^0$|^[1-9][0-9]{0,2}$/)}
            />
          </div>
        )),
      new AGridColDef("dateControl", "Date control", false)
        .setMinWidth(210)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) =>
          params?.value ? (
            <div>
              <Tooltip title={params?.value?.value}>
                <div className={`ellipsis-text-container`}>
                  {params?.value?.value}
                </div>
              </Tooltip>
            </div>
          ) : (
            <div>-</div>
          )
        )
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.dateControl}
              handleChange={(value) => rowFormHandler(value, "dateControl")}
              items={dateControlDropdown}
              isMulti={false}
              style={selectStyles}
              placeHolder={"Enter"}
              autoFocus={params?.hasFocus}
            />
          </div>
        )),
      new AGridColDef("logs", "Logs", false)
        .setMinWidth(80)
        .editable(false)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          <div>
            <Tooltip title={params?.value}>
              <div style={viewTextStyle}>
                <AuditLogDialogWithButton 
                 academicCarrierDropdown = {dropdown?.academicCareer}
                 getAcdLabelValue = {getAcdLabelValue}
                 row={params?.row} />
              </div>
            </Tooltip>
          </div>
        )),
      new AGridColDef("ticketId", "Ticket Id", true)
        .setMinWidth(128)
        .editable(true)
        .setFlex(0.7)
        .renderCellComponent((params) =>
          params?.value ? (
            <div>
              <Tooltip title={params?.value}>
                <div className={`ellipsis-text-container`}>
                  {params?.value}
                </div>
              </Tooltip>
            </div>
          ) : (
            <div>-</div>
          )
        )
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AInput
              value={rowForm?.ticketId}
              placeHolder={"Enter"}
              handler={(value) => rowFormHandler(value, "ticketId")}
              style={AInputStyle}
            />
          </div>
        )),

      new AGridColDef("updatedBy", "Last Updated", false)
        .setMinWidth(120)
        .editable(false)
        .setFlex(0.5)
        .renderCellComponent((params) =>
          params?.value ? (
            <div>
              <Tooltip
                title={`${moment(params?.row?.updatedOn).format(
                  "DD-MMM-YY"
                )} by ${params.value}`}
              >
                <div className={`ellipsis-text-container`}>{params?.value}</div>
              </Tooltip>
            </div>
          ) : (
            <div>-</div>
          )
        ),
      new AGridColDef("status", "Status", false)
        .setMinWidth(100)
        .setFlex(0.5)
        .editable(true)
        .renderCellComponent((params) => (
          <CustomChip
            text={params?.value}
            textColor={params?.value == "ACTIVE" ? "#07794C" : "#DC2804"}
            bgColor={params?.value == "ACTIVE" ? "#E6F4ED" : "#FCEEED"}
            // style={{ fontSize: 12,fontWeight:'400px', fontFamily: 'Gilroy-SemiBold' }}
          />
        ))
        .renderEditCellComponent((params) => (
          <StatusCellComponent
            params={params}
            toggleStatusHandler={toggleStatusHandler}
            rowForm={rowForm}
            rowFormHandler={rowFormHandler}
          />
        )),
      new AGridColDef("actions", "Actions", false)
        .setMinWidth(130)
        .columnAlign("right")
        .setFlex(0.5)
        // .pinColumnLast(true)
        .renderCellComponent((params) => (
          <>
            <ActionsCellComponent
              params={params}
              handleEditClick={handleEditClick}
              handleCancelClick={handleCancelClick}
              handleSaveClick={handleSaveClick}
              rowForm={rowForm}
              isTypeSelected={!concessionCategory?.id}
              isUserPermission={userPermissions}
              // deleteHandler={deleteHandler}
            />
          </>
        )),
    ];
    return (
      <div className="mt-3">
        <ADataGrid
          removeWrapperContainer
          rowModesModel={rowModesModel}
          rows={rowData || []}
          columns={columns}
          rowId={(row) => row?.id}
          rowHeight={50}
          rowCount={rowCount}
          loading={false}
          currentPage={currentPage}
          nextButtonHandler={() => {}}
          components={{
            ...gridComponents,
            NoRowsOverlay: () => (
              <NoRowOverlay message={loader ? "Loading..." : null} />
            ),
          }}
          sx={{
            ...gridStyles,
          }}
          autoHeight
          hidePagination={rowCount <= 50}
          // pinLastColumn
        />
      </div>
    );
  }
);
export default ListComponent;
